function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSorensonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 30,
    viewBox: "0 0 228 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ufdgzvhqza"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h40.365v28.852H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8",
    transform: "translate(0 .759)",
    style: {
      clipPath: "url(#ufdgzvhqza)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M1.441 14.426H16.92a5.763 5.763 0 0 0 4.942-2.8L27.577 2.1A4.323 4.323 0 0 1 31.284 0h7.641a1.442 1.442 0 0 1 1.441 1.443v11.54a1.442 1.442 0 0 1-1.441 1.443H23.449a5.763 5.763 0 0 0-4.944 2.8l-5.7 9.52a4.323 4.323 0 0 1-3.708 2.1H1.441A1.442 1.442 0 0 1 0 27.409v-11.54a1.442 1.442 0 0 1 1.441-1.443z",
    style: {
      fill: "#3dcdc2",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "m213.356 20.236 5.622-.36a.358.358 0 0 1 .379.337c.175 2.808 2.4 4.681 5.513 4.681 2.763 0 4.711-1.381 4.711-3.455 0-1.789-1.218-2.885-3.411-3.252l-3.534-.487c-6.254-.854-8.812-4.349-8.812-8.7 0-5.326 4.385-8.983 10.761-8.983 5.872 0 10.464 3.8 10.636 8.828a.362.362 0 0 1-.342.377l-5.752.29a.358.358 0 0 1-.374-.332 4.258 4.258 0 0 0-4.453-4.119c-2.523 0-4.06 1.341-4.06 3.332 0 1.666 1.056 2.763 3.045 3.09l3.534.53c6.294.812 9.218 4.389 9.218 8.82 0 5.448-4.629 9.187-11.369 9.187s-11.464-3.827-11.649-9.412a.356.356 0 0 1 .337-.365z",
    transform: "translate(-159.86 -.02)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M313.81 42.983a11.255 11.255 0 1 1 11.25 10.883 10.9 10.9 0 0 1-11.25-10.883zm16.2 0c0-3.371-2.031-5.645-4.954-5.645s-4.953 2.273-4.953 5.645 2.031 5.645 4.953 5.645 4.957-2.316 4.957-5.645z",
    transform: "translate(-235.499 -24.035)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M493.178 44.69h-13.763a.362.362 0 0 0-.359.4 4.36 4.36 0 0 0 4.434 4.068 4.136 4.136 0 0 0 4.108-2.65.359.359 0 0 1 .369-.25l4.769.392a.364.364 0 0 1 .327.419c-.644 3.978-4.537 6.8-9.573 6.8-6.294 0-10.761-4.467-10.761-10.883s4.345-10.923 10.558-10.923 10.356 4.385 10.356 10.681a11.681 11.681 0 0 1-.11 1.637.364.364 0 0 1-.357.312zm-6.039-3.818a.359.359 0 0 0 .359-.384 4.248 4.248 0 0 0-8.437-.017.357.357 0 0 0 .357.4h7.719z",
    transform: "translate(-354.571 -24.035)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "m653.427 46.336 4.978-.142a.361.361 0 0 1 .367.322c.2 1.637 1.575 2.673 3.631 2.673 1.787 0 2.965-.731 2.965-1.869 0-1.218-.893-1.7-2.68-1.989l-2.72-.447c-4.507-.649-6.538-2.8-6.538-6.376 0-4.182 3.534-7.107 8.57-7.107s8.632 2.79 8.954 6.848a.36.36 0 0 1-.352.389l-4.906.107a.357.357 0 0 1-.362-.307A3.194 3.194 0 0 0 662 35.747c-1.5 0-2.64.853-2.64 2.031 0 .933.649 1.542 1.909 1.747l2.763.447c4.831.731 7.349 3.087 7.349 6.621 0 4.1-3.7 6.945-8.974 6.945s-9.069-2.79-9.326-6.815a.362.362 0 0 1 .349-.384z",
    transform: "translate(-489.787 -23.54)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M733.79 42.983a11.256 11.256 0 1 1 11.25 10.883 10.9 10.9 0 0 1-11.25-10.883zm16.2 0c0-3.371-2.031-5.645-4.954-5.645s-4.953 2.273-4.953 5.645 2.031 5.645 4.953 5.645 4.957-2.316 4.957-5.645z",
    transform: "translate(-550.224 -24.035)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M574.124 34.285a2.44 2.44 0 0 1 1.288-1.061 6.728 6.728 0 0 1 2.2-.354c4.629 0 7.716 3.329 7.716 8.365v12.27a.358.358 0 0 1-.359.359h-5.5a.358.358 0 0 1-.359-.359V42.168c0-2.72-1.34-4.3-3.656-4.3s-3.7 1.7-3.7 4.629V53.5a.358.358 0 0 1-.359.359H565.9a.358.358 0 0 1-.359-.359V33.636a.358.358 0 0 1 .359-.359h5.483a.359.359 0 0 1 .359.372l-.135 4.17a.18.18 0 0 0 .334.1l2.171-3.631z",
    transform: "translate(-424.162 -24.643)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M841.164 34.285a2.44 2.44 0 0 1 1.288-1.061 6.728 6.728 0 0 1 2.2-.354c4.629 0 7.716 3.329 7.716 8.365v12.27a.358.358 0 0 1-.359.359h-5.5a.358.358 0 0 1-.359-.359V42.168c0-2.72-1.34-4.3-3.656-4.3s-3.7 1.7-3.7 4.629V53.5a.358.358 0 0 1-.359.359h-5.5a.358.358 0 0 1-.359-.359V33.636a.358.358 0 0 1 .359-.359h5.483a.359.359 0 0 1 .359.372l-.135 4.17a.18.18 0 0 0 .334.1l2.171-3.631z",
    transform: "translate(-624.369 -24.643)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M419.106 42.095a2.641 2.641 0 0 1 2.64-2.64h4.891a.357.357 0 0 0 .357-.357v-4.956a.356.356 0 0 0-.307-.354 13.552 13.552 0 0 0-1.732-.1 6.01 6.01 0 0 0-2.236.419 2.466 2.466 0 0 0-1.193 1.026l-2.291 3.828a.18.18 0 0 1-.334-.1l.187-4.6a.36.36 0 0 0-.359-.374h-5.48a.358.358 0 0 0-.359.359v19.875a.358.358 0 0 0 .359.359h5.495a.358.358 0 0 0 .359-.359V42.095z",
    transform: "translate(-309.714 -25.258)",
    style: {
      fill: "#080f13"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorensonLogo);
export default __webpack_public_path__ + "static/media/SorensonLogo.b5aea9436950086a73cc65db40c8776e.svg";
export { ForwardRef as ReactComponent };